import { capitalize } from 'lodash';

import { EscrowPartyTypeEnum } from 'src/graphql/schema';
import { Card, CardContent, CardHeader, CardTitle, CardDescription, CardFooter } from '@/components/ui/card';

import { EmptyInvitation, InvitationView, EditInvitationDialog } from '.';

import { EscrowInvitationContextProvider, useEscrowInvitationContext } from '../model';

const Container = () => {
  const { escrowInvitation, invitePartyType, canInviteParty } = useEscrowInvitationContext();

  if (!escrowInvitation) return <EmptyInvitation invitePartyRole={invitePartyType} canAdd={canInviteParty} />;

  return (
    <Card className="h-full flex flex-col">
      <CardHeader className="shrink-0">
        <CardTitle>{capitalize(invitePartyType)} organization & primary contact</CardTitle>
        <CardDescription>
          Which organization should be listed as the {invitePartyType}, and who is their primary contact?
        </CardDescription>
      </CardHeader>
      <CardContent className="grow">
        <InvitationView
          companyName={escrowInvitation.companyName}
          userName={escrowInvitation.userName}
          userEmail={escrowInvitation.userEmail}
        />
      </CardContent>
      {escrowInvitation?.policy.update && (
        <CardFooter className="pt-6 shrink-0">
          <div className="flex justify-end bg-muted w-full py-2 px-4">
            <EditInvitationDialog />
          </div>
        </CardFooter>
      )}
    </Card>
  );
};

type Props = {
  escrowId: string;
  invitationId: string | null;
  invitePartyType: EscrowPartyTypeEnum;
  canInviteParty: boolean;
};

const PartyInvitationContainer = ({ escrowId, invitePartyType, invitationId, canInviteParty }: Props) => {
  return (
    <EscrowInvitationContextProvider
      escrowId={escrowId}
      invitationId={invitationId}
      invitePartyType={invitePartyType}
      canInviteParty={canInviteParty}
    >
      <Container />
    </EscrowInvitationContextProvider>
  );
};

export default PartyInvitationContainer;
